import React from 'react';

import clsx from 'clsx';

import * as classes from './ArithmeticBlock.module.css';

const ArithmeticBlock = ({
    innerEditor,
    parentId,
    id,
    value,
    ...props
}) => {

    return (
        <span style={{ display: 'flex', alignItems: 'center' }} id={`${id}-arithmetic-block`}>
            <React.Fragment>&nbsp;</React.Fragment>
            <div
                data-parentId={parentId}
                data-id={id}
                id={`${id}-arithmetic-block`}
                className={classes.ArithmeticBlock}
            >
                <div className={classes.ArithmeticContainer}>
                    <div className={classes.LabelContainer}>
                        { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                        <label className={classes.Label}>Function</label>
                        { /* eslint-disable-next-line jsx-a11y/no-onchange */}
                        <select data-select-id={id} defaultValue={value} className={classes.Select}>
                            <option>+</option>
                            <option>-</option>
                            <option>*</option>
                            <option>/</option>
                            <option>%</option>
                            <option>^</option>
                        </select>
                    </div>
                </div>
                <span
                    id={`${id}-delete`}
                    role="none"
                    class={clsx('material-icons-outlined', classes.DeleteIcon)}
                >
                    delete
                </span>
            </div>
            <React.Fragment>&nbsp;</React.Fragment>
        </span>
    );
};

export default ArithmeticBlock;
